module.exports = __webpack_public_path__ + "static/img/contect_4_03.0ecacbce.jpg";